// eslint-disable-next-line import/prefer-default-export
export const OUTAGE_TIME_FORMAT = 'hh:mma';
export const MAINTENANCE = 'Maintenance';
export const GENERAL = 'General';
export const BUG = 'Bug';
